/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';

export default class Instagram extends Component {
  render() {
    return (
      <>
        <div className="instagram">
          <a name="social" />
          <h1>INSTAGRAM</h1>
          <div className="instatiles">
            <a
              className="insta1"
              href="https://www.instagram.com/p/BsvgO01lKV5/"
              target="_blank"
              rel="noopener noreferrer"
              alt=""
            />
            <a
              className="insta2"
              href="https://www.instagram.com/p/Bsy3ZuOl-8W/"
              target="_blank"
              rel="noopener noreferrer"
              alt=""
            />
            <a
              className="insta3"
              href="https://www.instagram.com/p/BsgYWSPBNur/"
              target="_blank"
              rel="noopener noreferrer"
              alt=""
            />
            <a
              className="insta4"
              href="https://www.instagram.com/p/BsYsMaChxpE/"
              target="_blank"
              rel="noopener noreferrer"
              alt=""
            />
            <a
              className="insta5"
              href="https://www.instagram.com/p/Bsdn84ZhYn0/"
              target="_blank"
              rel="noopener noreferrer"
              alt=""
            />
            <a
              className="insta6"
              href="https://www.instagram.com/p/Bsdihs8BF_2/"
              target="_blank"
              rel="noopener noreferrer"
              alt=""
            />
            <a
              className="insta7"
              href="https://www.instagram.com/p/BsdbA7DBFhU/"
              target="_blank"
              rel="noopener noreferrer"
              alt=""
            />
            <a
              className="insta8"
              href="https://www.instagram.com/p/BsYnK1xhpNC/"
              target="_blank"
              rel="noopener noreferrer"
              alt=""
            />
          </div>
          <a
            className="button"
            href=" https://www.instagram.com/wearejupiterlanding/"
            target="_blank"
          >
            VIEW ALL
          </a>
        </div>
      </>
    );
  }
}
